import React, { useEffect, useState } from "react";
/* import {
  Card,
  CardContent,
  Typography,
  Grid,
  Button,
  CircularProgress,
  Snackbar,
  Alert,
} from "@mui/material"; */
import axios from "axios";
import { baseUrl, config, requestID } from "../common/utils";

const ElectionVotingPage = () => {
  const [positions, setPositions] = useState([]);
  const [electionName, setElectionName] = useState("");
  const [loading, setLoading] = useState(true);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const [confirmOpen, setConfirmOpen] = useState(false);
  const [selectedCandidate, setSelectedCandidate] = useState(null);

 

  const fetchElectionData = async () => {
    try {
      setLoading(true);
      const payload = { requestID: requestID() };

      const response = await axios.post(
        baseUrl() + "elections/getAspirantsByPosition ⁠",
        payload,
        config
      );

      console.log("Response:", response); // Debugging line
      if (response.data.status) {
        setElectionName(response.data.election_name);
        setPositions(response.data.positions);
        console.log("Response:", response); // Debugging line

      } else {
        setSnackbar({
          open: true,
          message: "No active election found.",
          severity: "warning",
        });
        console.log("Response:", response); // Debugging line

      }
    } catch (error) {
      setSnackbar({
        open: true,
        message: "Failed to fetch election data.",
        severity: "error",
      });
      console.log("Response:1"); // Debugging line

    } finally {
      setLoading(false);
      console.log("Response:2"); // Debugging line

    }
  };

  const xfetchElectionData = async () => {
    try {
      //  const response = await axios.get('https://your-api-endpoint.com/election/aspirants'); // Replace with your real API

      const response = await axios.post(
        baseUrl() + "elections/getAspirantsByPosition",
        { requestID: requestID() },
        config
      );
      if (response.data.status) {
        setElectionName(response.data.election_name);
        setPositions(response.data.positions);
      } else {
        setSnackbar({
          open: true,
          message: "No active election found.",
          severity: "warning",
        });
      }
    } catch (error) {
      setSnackbar({
        open: true,
        message: "Failed to fetch election data.",
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleVote = async (candidateId) => {
    try {
      const response = await axios.post(
        "https://your-api-endpoint.com/election/cast-vote",
        {
          candidate_id: candidateId,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`, // Use your auth system
          },
        }
      );

      if (response.data.status) {
        setSnackbar({
          open: true,
          message: response.data.message,
          severity: "success",
        });
      } else {
        setSnackbar({
          open: true,
          message: response.data.message,
          severity: "error",
        });
      }
    } catch (error) {
      setSnackbar({
        open: true,
        message: "Error casting vote.",
        severity: "error",
      });
    }
  };

  if (loading)
    return <CircularProgress style={{ margin: "auto", display: "block" }} />;


  useEffect(() => {
    fetchElectionData();
  }, []);
/*
  return (
    <div style={{ padding: 20 }}>
      <Typography variant="h4" gutterBottom>
        {electionName}
      </Typography>
      {positions.map((pos, index) => (
        <Card key={index} style={{ marginBottom: 20 }}>
          <CardContent>
            <Typography variant="h5" gutterBottom>
              {pos.position_name}
            </Typography>
            <Grid container spacing={2}>
              {pos.aspirants.map((aspirant) => (
                <Grid item xs={12} md={6} key={aspirant.id}>
                  <Card variant="outlined">
                    <CardContent>
                      <Typography variant="h6">{aspirant.full_name}</Typography>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => handleVote(aspirant.id)}
                        style={{ marginTop: 10 }}
                      >
                        Vote
                      </Button>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </CardContent>
        </Card>
      ))}

      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert
          severity={snackbar.severity}
          onClose={() => setSnackbar({ ...snackbar, open: false })}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </div>
  );*/
};

export default ElectionVotingPage;
